'use client';

import { Suspense } from 'react';

export default function FooterScript({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <Suspense>
      <div id="everything" className="everything">
        <div id="content">
          <div id="body" className="body" />
          {children}
        </div>
        <div id="footer" className="footer" />
      </div>
    </Suspense>
  );
}
